import React, { useEffect, useState } from "react";
import { api, imageUrl } from "../lib/api";
import { Star, Quote } from "lucide-react";

export const ReviewsSection = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const r = await api.get("/reviews");
        if (alive) setReviews(Array.isArray(r.data) ? r.data.slice(0, 6) : []);
      } catch {
        if (alive) setReviews([]);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, []);

  if (loading || reviews.length === 0) return null;

  return (
    <section
      id="testimonianze"
      className="bg-midnight text-white py-16 md:py-24 border-y border-gold/20"
      data-testid="reviews-section"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="max-w-2xl mb-14">
          <div className="inline-flex items-center gap-3 mb-4">
            <span className="divider-gold" />
            <span className="text-gold text-xs uppercase tracking-[0.3em] font-medium">
              Testimonianze
            </span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-bold leading-tight">
            Cosa dicono <span className="italic text-gold">i clienti</span>
          </h2>
          <p className="text-white/60 mt-4 max-w-xl leading-relaxed">
            Chi ha già scelto Guzzardella Auto racconta la propria esperienza. Ogni auto è selezionata
            personalmente da Rocco per garantire trasparenza e qualità.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((r) => (
            <article
              key={r.id}
              className="relative border border-white/10 bg-midnight-light p-8 pt-10 hover:border-gold/40 transition-colors group"
              data-testid={`review-card-${r.id}`}
            >
              <Quote
                size={36}
                className="absolute -top-4 left-6 text-gold bg-midnight px-1"
                strokeWidth={1.5}
              />
              <div className="flex items-center gap-1 mb-4" aria-label={`${r.rating} stelle su 5`}>
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star
                    key={i}
                    size={14}
                    className={i < (r.rating || 0) ? "text-gold" : "text-white/15"}
                    fill={i < (r.rating || 0) ? "currentColor" : "none"}
                    strokeWidth={2}
                  />
                ))}
              </div>
              <blockquote className="text-white/85 leading-relaxed mb-6 text-[15px]">
                {r.content}
              </blockquote>
              <div className="pt-4 border-t border-white/5 flex items-center gap-3">
                {r.photo_path && (
                  <img
                    src={imageUrl(r.photo_path)}
                    alt={`Foto di ${r.author_name}`}
                    className="w-12 h-12 rounded-full object-cover border border-gold/40 shrink-0"
                    loading="lazy"
                    data-testid={`review-photo-${r.id}`}
                  />
                )}
                <div className="min-w-0">
                  <p className="font-display text-lg text-gold truncate" data-testid={`review-author-${r.id}`}>
                    {r.author_name}
                  </p>
                  {r.location && (
                    <p className="text-[11px] uppercase tracking-widest text-white/40 mt-1">
                      {r.location}
                    </p>
                  )}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;
